<template lang="pug">
  v-hover(v-if='team' v-slot:default="{ hover }")
    v-card.card-style
      v-row.row-name-style.mt-3
        .name-team.sm-fs-name-team.text-none {{team.name}}
      v-row.mt-3.ml-8
        .name-IThierarchy.text-uppercase {{team.it_hierarchy}}
      p.sub-text.text--disabled.mt-3.ml-8 {{team.count_employee}}
      v-row.ml-8
        v-card.card-mony.elevation-0
          p.text-sw от
          p.mony-text-sw {{ team.price }}
          p.mony-text-sw.ml-1
            font-awesome-icon.icon-tc(:icon="['fas', 'ruble-sign']")
      v-row.group-technology-row.ml-6.mb-4
        v-chip.chip-technology.text-uppercase(
          v-for="technology in team.technologys"
          small
          ) {{technology.name}}
      v-row.rowStyleSm
        template(v-for="(technology, i) in team.technologys")
          v-container.ml-2.img-sm(v-if="technology.is_show && i<3" :style="`background-image: url(\"${technology.get_image}\")`")
      v-card.sm-card-style.elevation-0
        v-row.mx-auto.d-flex.justify-center.align-end
          v-btn.text-capitalize.btn-style(@click="booking")
            | Забронировать

</template>

<script>

export default {
  name: "SwiperSpecialistTeamCard",
  props: {
    team: {
      type: Object,
      default: () => {}
    },
    num: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    booking () {
      this.$vuetify.goTo('#registration', {offset:-45})
      this.$emit('onBooking', this.team.name)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "scss/colors.scss"
  @import "scss/variables.scss"

  .card-style
    position: relative
    border-radius: 20px !important
    margin-bottom: 2%
    min-width: 300px
    min-height: 470px
    padding-top: 10px
    margin-right: 4.5%


  .img-sm
    background-size: contain
    background-position: center
    width: 25px
    height: 25px
    margin-left: 0
    margin-right: 10px

  .name-team
    font-family: GothamProMedium
    font-style: normal
    font-weight: 400
    line-height: 120%

  .sm-fs-name-team
    font-size: calc(19px + 0.6vw)

  .name-IThierarchy
    font-family: GothamProMedium
    font-size: min(calc(12px + 0.4vw), 18px)
    color: $blueBasic
    margin-right: 7%
    margin-top: 1%
    padding-right: 7px

  .row-name-style
    margin-left: 32px

  .sub-text
    font-family: GothamProMedium
    font-size: calc(13px + 0.3vw)

  .card-mony
    color: $blueBasic
    display: flex
    max-width: 200px
    width: 100%
    .text-sw
      font-family: GothamProMedium
      justify-content: center
      align-content: center
      margin-top: 6%
      margin-right: 5px
      display: grid
      margin-bottom: 0
      font-size: 16px
    .mony-text-sw
      font-family: GothamProMedium
      font-size: 16pt
      justify-content: center
      margin-top: 5%
      margin-bottom: 0

  .icon-tc
    margin-bottom: 1px
    font-family: GothamProMedium
    color: $blueBasic
    font-size: 18px !important

  .group-technology-row
    display: flex
    flex-wrap: wrap
    justify-content: left
    margin-right: 7%
    .chip-technology
      font: 12px GothamProClassic
      margin-left: 8px
      margin-top: 5%
      background: $chipFont

  .btn-style
    margin-top: 15px
    elevation: 0
    color: white
    font: $btnFont
    background: $btnColor
    letter-spacing: 0.01em
    width: 191px

  .sm-card-style
    position: absolute
    width: 100%
    bottom: 10%
    transform: translateY(50%)

  .rowStyleSm
    margin-right: 2%
    margin-left: 28px !important



</style>